<template>
	<div class="t-page_courses t-work-area">
		<h1>{{ pageText.title }}</h1>
		<div class="t-notice-info">
			<p class="t-notice-info__count">{{ pageText.notice }} {{ notice._meta.totalCount || pageText.no }}</p>
			<button v-if="notice.items.length" class="t-notice-info__clear" @click.prevent="Clear()">
				{{ pageText.noticeDelete }}
				<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 1L13 13M13 1L1 13" stroke="#52A8F2" stroke-width="2"/>
				</svg>
			</button>
		</div>
		<h3 v-if="countNotice(true) > 0" class="t-notice-title">{{ pageText.titleNew }}</h3>
		<div v-if="countNotice(true) > 0 && !mobileState" class="t-notice-list">
			<cmp-notice v-for="(item, index) in notice.items" :key="'notice_' + index" :data="item" :showItem="item.new"></cmp-notice>
		</div>

		<div v-if="countNotice(true) > 0 && mobileState" class="t-notice-list">
			<cmp-notice v-if="index < visibleBtn" v-for="(item, index) in notice.items" :key="'notice_' + index" :data="item" :showItem="item.new"></cmp-notice>
		</div>
		<div v-if="visibleBtn < countNotice(true) && mobileState" @click="countVisibleNotice()" class="t-notice-btn">
			{{ pageText.textBtn }}
		</div>
		<h3 v-if="countNotice(false) > 0" class="t-notice-title">{{ pageText.titleOld }}</h3>
		<div v-if="countNotice(false) > 0" class="t-notice-list">
			<cmp-notice v-for="(item, index) in notice.items" :key="'notice_' + index" :data="item" :showItem="!item.new"></cmp-notice>
			<cmp-pagination class="t-pagination_top" v-if="notice._meta.pageCount > 1" :pages="notice._meta.pageCount"></cmp-pagination>
		</div>

	</div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/noticePage.json' : 'staticText',
        main: {
            title: "Уведомления",
			notice: "Уведомлений",
			no: "нет",
			noticeDelete: "Удалить все уведомления",
            titleNew: "Новые",
            titleOld: "Прочитанные",
			textBtn: "Показать ещё"
        }
    };

    import {store} from '../../store/index'

    import {mapGetters, mapActions} from 'vuex'
		import Notice from '../../vue_components/Notice'
    import Pagination from '../../vue_components/Pagination'

		export default {
        data(){
            return {
                pageText: {},
				visibleBtn: 8
						}
				},
        components: {
            'cmp-pagination': Pagination,
            'cmp-notice': Notice
				},
        computed: {
            ...mapGetters('notice', ['notice']),
            ...mapGetters(['newNotice', 'mobileState'])
        },
				watch: {
            newNotice(){
                if(this.newNotice > 0 && (!this.$route.query.page || parseInt(this.$route.query.page) === 1)){
                    this.LoadNotice(this.$route.query);
										this.ClearNotice();
								}
						}
				},
		methods: {
						...mapActions('notice', ['LoadNotice']),
            ...mapActions(['ClearNotice', 'UpdatePreloadState']),
            Clear(){
                this.$http.delete('notice')
                    .then(response => response.json())
                    .then(data => {
                        this.LoadNotice({page: 1});
                    })
						},
            Load(pageText){
                this.pageText = pageText;
                if(!this.$route.query.page || parseInt(this.$route.query.page) === 1)
                		this.ClearNotice();

                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            },
            countNotice(t) {
				let count = 0;
				for (let i = 0; i < this.notice.items.length; i++) {
				    if (this.notice.items[i].new === t) {
				        count += 1;
					}
				}
				return count;
			},
            countVisibleNotice() {
						    this.visibleBtn += 8;
			}
		},
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteUpdate (to, from, next) {
            if(!to.query.page || parseInt(to.query.page) === 1)
                this.ClearNotice();

            store.dispatch('notice/LoadNotice', to.query).then(() => {
                next();
            });
        },
        beforeRouteEnter (to, from, next) {
            let props = {};
            for(let key in to.query){
                props[key] = to.query[key]
            }
            if(props.page === undefined)
                props.page = 1;

            let count = 0;
            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });
            store.dispatch('notice/LoadNotice', props).then(() => {count++;RunNext();});
            let RunNext = () => {
                if(count > 1)
                    next(vm => vm.Load(pageText))
            }
        }
		}
</script>

<style lang="sass">
.t-notice-info
	display: flex
	align-items: center
	flex-wrap: wrap
	margin: 0 0 32px
	&__count
		font-size: 16px
		margin-right: 60px
	&__clear
		font-size: 16px
		color: $blue
		font-weight: normal
		font-family: 'rubik', Arial, sans-serif
		background: transparent
		border: none
		outline: none
		cursor: pointer
		display: flex
		align-items: center
		svg
			margin-left: 20px
.t-notice-list
	display: flex
	//flex-wrap: wrap
	flex-direction: column
	width: 100%
	max-width: 960px
	@extend %substrate
	margin-bottom: 32px
	padding: 16px 24px

.t-notice-title
	padding: 24px
	margin-bottom: 24px
	font-weight: 600
	font-size: 22px
	color: $blue
	max-width: 960px
	@extend %substrate

.t-notice-btn
	padding: 10px 24px
	margin: 0 auto 32px
	border-radius: 20px
	box-shadow: 0 24px 32px rgba(0, 108, 202, 0.1)
	background-color: #ffffff
	font-size: 16px
	color: $blue
	font-weight: 600
	max-width: 272px
	text-align: center
	cursor: pointer

@media(max-width: 920px)
	.t-notice-title
		font-size: 20px
		padding: 0
		margin: 16px
		background: transparent
		box-shadow: none
	.t-notice-list
		background: transparent
		box-shadow: none
		padding: 0
		margin-bottom: 16px

@media(max-width: 769px)
	.t-notice-info
		padding: 0 16px
</style>


// WEBPACK FOOTER //
// src/vue_pages/Notice/Index.vue